module.exports = __webpack_public_path__ + "static/18(1)-cce0eb984e87c74a2a10e32f00e9687a.jpg";